import { inAppChatService } from '@egw/app-chat'
import { Alert, AlertType, Button, ButtonVariant } from '@egw/components'
import { WEALTH_ROUTES } from '@egw/constants'
import { sendEvent, setDeviceContext } from '@egw/events'
import { useTranslation } from '@egw/i18n'
import { useRouter } from '@egw/router'
import { ArrowLongLeftIcon } from '@heroicons/react/24/solid'
import { type FC } from 'react'
import { v4 as uuidv4 } from 'uuid'

export interface SignInHelpProps {
  onBack: () => void
}

export const SignInHelp: FC<SignInHelpProps> = ({ onBack }) => {
  const { t } = useTranslation('features-auth')
  const { navigate } = useRouter()

  return (
    <div className="flex flex-col items-center egw-container">
      <div className="w-full max-w-[470px] sm:max-w-[342px] md:w-[442px] pt-10 mt-4 mb-8">
        <button
          type="button"
          data-testid="backToSignIn_primary_btn"
          className="font-semibold text-white flex items-center"
          onClick={() => {
            onBack()
          }}
        >
          <ArrowLongLeftIcon className="h-6 w-6" />
          {t('sign_in_help.back_to_sign_in')}
        </button>
      </div>

      <div className="flex flex-col p-6 bg-white shadow-xl gap-5 rounded h-fit sm:max-w-[342px] md:w-[442px] relative z-10">
        <h2 className="font-light text-2xl text-center">{t('sign_in_help.title')}</h2>

        <Button
          onClick={() => {
            inAppChatService.open()
          }}
          className="flex items-center gap-2 py-4 mb-4"
          testId="contactSupport_primary_btn"
        >
          {t('sign_in_help.contact')}
        </Button>

        <div className="border-t flex justify-center">
          <span className="text-meta bg-white -mt-3 px-3">or</span>
        </div>

        <Alert alertType={AlertType.Warning} description={t('sign_in_help.reset_passkey_warning')} />

        <Button
          type="submit"
          variant={ButtonVariant.Secondary}
          className="w-full py-4"
          testId="recoveryLink_secondary_btn"
          onClick={() => {
            const passkeyRecoveryAttemptUID = uuidv4()
            // Use Generated  Recovery Attempt Unique ID
            // to propagates through all events on recovery flow
            setDeviceContext({
              passkeyRecoveryAttemptUID,
            })
            sendEvent('user_passkeyRecovery_click', {
              eventSource: 'egWealth',
              category: 'passkey-recovery',
              subCategory: 'intent',
            })
            navigate(WEALTH_ROUTES.RECOVERY.path)
          }}
        >
          {t('sign_in_help.reset_passkey')}
        </Button>
      </div>
    </div>
  )
}
